import MultipleLineAndBarChart from "../../../components/charts/MultipleLineAndBarChart";

const QualityChartSection = ({
  dataSetsSortingErrorByFluxChart,
  labelsByTimeChart,
  t,
}) => {
  return (
    <article className="statistics-card min-lg:flex-1 min-lg:min-w-0 flex flex-col self-stretch">
      <div className="dashboard-chart-heading shrink-0">
        <h5 className="dashboard-chart-title">
          {t("Sorting error by waste category")}
        </h5>
        <p className="dashboard-chart-subtitle">
          {t("quality.sortingErrorChart.subtitle")}
        </p>
      </div>

      <div className="relative w-full flex-1 min-h-[320px]">
        <div className="absolute inset-0">
          <MultipleLineAndBarChart
            stackedChart={false}
            type="bar"
            borderWidthChart={1}
            labelsChart={labelsByTimeChart}
            aspectRatioChart={1.2}
            datasetsChart={dataSetsSortingErrorByFluxChart}
            indexAxisChart="x"
            maintainAspectRatioChart={false}
            displayGrid={true}
            displayTicks={true}
            xAxisType={"time"}
            reverseChart={false}
            displayLegend={true}
            displayTooltip={true}
            messageLabelTooltip={t("sorting errors")}
            unitValueChart=""
            maxYAxis={null}
            maxBarThicknessChart={100}
            categoryPercentageChart={0.7}
          />
        </div>
      </div>
    </article>
  );
};

export default QualityChartSection;
